<template>
  <iframe id="ytplayer" type="text/html" width="100%" height="96%"
          src="https://www.youtube.com/embed/wk6Qr6OO5Xo"
          frameborder="0"/>
</template>

<script>

export default {
  name: 'VideoTile',
};
</script>

<style scoped>

</style>
